import * as React from "react";
const MenuWallet = (props) => (
  <svg
    width={19}
    height={17}
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.33301 5.58374H11.7497"
      stroke="#4B5155"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66602 12.2502H6.33268"
      stroke="#4B5155"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.41602 12.2502H11.7493"
      stroke="#4B5155"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9997 10.1917V11.9251C17.9997 14.8501 17.258 15.5834 14.2997 15.5834H5.03301C2.07467 15.5834 1.33301 14.8501 1.33301 11.9251V5.07508C1.33301 2.15008 2.07467 1.41675 5.03301 1.41675H11.7497"
      stroke="#4B5155"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.333 6.41675V1.41675L17.9997 3.08341"
      stroke="#4B5155"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3327 1.41675L14.666 3.08341"
      stroke="#4B5155"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default MenuWallet;